<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{topTitle}}</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>活动奖励管理</BreadcrumbItem>
        <BreadcrumbItem>{{topTitle}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" :rules='activitiesRewardRules' ref="activitiesRewardForm" class="edit-display">
      <FormItem label='奖励名称' prop='name' :label-width='90'>
        <Input type='text' v-model.trim="addEditParams.name" :maxlength="100" style="width:500px;"></Input>
      </FormItem>
      <FormItem label='奖励类型' :label-width='90'>
        <Select v-model="addEditParams.type" :disabled="addEditParams.rewardId != ''" style="width:500px" @on-change='changeType'>
          <Option v-for="(item, index) in rewardTypeList" :key="index" :value="item.type">{{item.name}}</Option>
        </Select>
      </FormItem>
      <template v-if="addEditParams.type !== 3">
        <FormItem label='优惠成本' :label-width='90'>
          <RadioGroup v-model="addEditParams.bearType">
            <Radio :label="2" :disabled="addEditParams.rewardId != '' && addEditParams.type !== 3" style="width: 150px;margin-left:8px;">业主承担</Radio>
            <Radio :label="1" :disabled="addEditParams.rewardId != '' && addEditParams.type !== 3">Xbed承担</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="addEditParams.type === 2" label='减免额' prop='discountPrice' :label-width='90' class="activity-reward">
          <div class="input-unit">原价满
            <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" class="input" v-model="addEditParams.originalPrice"></InputNumber>
            <span class="unit">元</span>
          </div>
          <div class="input-unit">减
            <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" class="input" v-model="addEditParams.discountPrice"></InputNumber>
            <span class="unit">元</span>
          </div>
        </FormItem>
        <FormItem v-if="addEditParams.type === 1" label='折扣额' prop='discountPrice' :label-width='90' class="activity-reward">
          <div class="input-unit">原价满
            <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" class="input" v-model="addEditParams.originalPrice"></InputNumber>
            <span class="unit">元</span>
          </div>
          <div class="input-unit">享
            <InputNumber type='text' :min="0.1" :max="10" :step="1" class="input" v-model="addEditParams.discount"></InputNumber>
            <span class="unit">折</span>
          </div>
          <div class="input-unit">最高减
            <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" class="input" v-model="addEditParams.maxDiscountPrice"></InputNumber>
            <span class="unit">元</span>
          </div>
        </FormItem>
        <FormItem v-if="addEditParams.type === 5" label='兑换额' prop='discountPrice' :label-width='90' class="activity-reward">
          <div class="input-unit">原价满
            <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" class="input" v-model="addEditParams.originalPrice"></InputNumber>
            <span class="unit">元</span>
          </div>
          <div class="input-unit">减房费
            <InputNumber type='text' :min="1" :max="999" :step="1" class="input" v-model="addEditParams.roomNight"></InputNumber>
            <span class="unit">晚</span>
          </div>
          <div class="input-unit">最高减
            <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" class="input" v-model="addEditParams.maxDiscountPrice"></InputNumber>
            <span class="unit">元</span>
          </div>
        </FormItem>
        <FormItem :label-width='100' style="margin-top: -5px;">
          <span style="color: red">{{rewardTips[addEditParams.type]}}</span>
        </FormItem>
      </template>
    </Form>
    <Form v-if="addEditParams.type === 3" @submit.native.prevent="preventSubmit" :rules='activitiesRewardRules' ref="addCouponForm">
      <FormItem label='优惠券ID' prop='couponIds' :label-width='90'>
        <Input type='text' v-model.trim="couponParam.couponIds" style="width:430px;margin-right:10px;"></Input>
        <Button type="primary" :loading="couponParam.loading" @click="addCoupon()">添加</Button>
      </FormItem>
      <Content style="margin-left:20px;" class="reward-send">
        <Table :columns="columnsList" :data="couponParam.couponData" style='width:1304px;'></Table>
        <!-- <div style="margin: 10px;overflow: hidden">
          <Page placement="bottom" show-sizer :total="frontEndPageConfig.count" :current="frontEndPageConfig.page" @on-page-size-change="changeFrontEndPagesPageSize" @on-change="changeFrontEndPagesPage"></Page>
        </div> -->
      </Content>
    </Form>
    <Button style="margin:24px;width:127px;" type="primary" :loading="saveLoading" @click="saveAddOrEdit">保存</Button>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
import MIXINS from '../../mixins/index.js'
import { strRegExp } from "@/utils/regular"
export default {
  mixins: [MIXINS.FRONT_END_PAGES],
  data () {
    const validateActivity = {
      name:(rule,value,callback) =>{
        if (!this.addEditParams.name) {
          callback(new Error('请填写奖励名称'))
        }else if(!strRegExp.test(this.addEditParams.name)){
          callback(new Error('存在空格和不支持的符号，请修改'));
        }else{
          callback()
        }
      },
      couponIds:(rule,value,callback) =>{
        if (!this.couponParam.couponIds) {
          callback(new Error('请填写优惠券id'))
        }else{
          if (this.couponParam.couponData.length) {
            for (let value of this.couponParam.couponData) {
              if (value.cardId === this.couponParam.couponIds) {
                callback(new Error('该优惠券已添加'))
                return
              }
            }
          }
          callback()
        }
      },
      discountPrice:(rule,value,callback) =>{
        let params = this.addEditParams
        if (!params.originalPrice || 
          (params.type === 2 && !params.discountPrice) || 
          (params.type === 1 && (!params.discount || !params.maxDiscountPrice)) || 
          (params.type === 5 && (!params.roomNight || !params.maxDiscountPrice))) {
          callback(new Error('请填写优惠信息'))
        }else{      
          let resg = /.*\..*/     
          if (resg.test(String(params.originalPrice)) && String(params.originalPrice).split(".")[1].length > 2 || 
              resg.test(String(params.discountPrice)) && String(params.discountPrice).split(".")[1].length > 2 || 
              resg.test(String(params.maxDiscountPrice)) && String(params.maxDiscountPrice).split(".")[1].length > 2) {
            callback(new Error('金额只能填写整数或两位小数'))
          }
          if (params.type === 1 && String(params.discount).indexOf(".") && String(params.discount).length > 3) {
            callback(new Error('折扣只能填写整数或一位小数'))
          }
          if (params.type === 5 && (resg.test(String(params.roomNight)) || Number(params.roomNight) % 1 !== 0)) {
            callback(new Error('房晚只能填写整数'))
          }
          callback()
        }
      },
    }
    return {
      size:10,
      page:1,
      dataList:[],
      selectDataList:[],
      listTotal:0,
      columnsList:[
        {
          title:'优惠券ID',
          key:'cardId',
          align:'center',
          width:200,
          render: (h, params) => {
            return h('span', {}, params.row.cardId ? params.row.cardId : params.row.couponIds)
          }
        },
        {
          title:'优惠券名称',
          key:'title',
          align:'center',
          width:250,
          render: (h, params) => {
            return h('span', {
              style: {
                overflow: 'hidden',
                webkitLineClamp: 5,
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all',
                display: '-webkit-box',
                margin: '8px 0'
              },
              attrs: {
                title: params.row.title
              }
            }, params.row.title)
          }
        },
        {
          title:'优惠成本',
          key:'bearParty',
          align:'center',
          width:150,
          render: (h, params) => {
            return h('span', {}, ['', 'Xbed承担', '业主承担'][params.row.bearParty])
          }
        },
        {
          title:'优惠类型',
          key:'couponCardType',
          align:'center ',
          width:150,
          render:(h,params) =>{
            const status = ['', '兑换券', '代金券', '折扣券'][params.row.couponCardType]
            return h('span', {}, status)
          }
        },
        {
          title:'优惠内容',
          align:'center',
          width: 300,
          render: (h, params) => {
            let text = `原价满${params.row.leastCost / 100}元 `
            switch (params.row.couponCardType) {
              case 3:
                text += `享${params.row.discount / 10}折 最高减${params.row.maxCost / 100}元`
                break;
              case 2:
                text += `减${params.row.reduceCost / 100}元`
                break;
              case 1:
                text += `减房费${params.row.exchangeNumber}晚 最高减${params.row.maxCost / 100}元`
                break;
              default:
                break;
            }
            return h('span', {}, text)
          }
        },
        {
          title:'赠送数量',
          align:'center',
          width:150,
          render: (h, params) => {
            return h('inputNumber', {
              props: {
                value: params.row.quantity || 1,
                type: 'number',
                min: 1,
                max: 99,
                step: 1
              },
              style: {
                width: '100px',
              },
              on:{
                input: (value)=>{
                  this.couponParam.couponData.map((item, index) => {
                    if (params.index === index) item.quantity = value
                  })
                }
              }
            })
          }
        },
        {
          title:'操作',
          align:'center',
          width:100,
            render:(h,param) => {
            return h('div',
            [
              h('Button',{
                props:{
                  type:'error',
                  size:'small'
                },
                on:{
                  click:()=>{
                    this.deleteBtn(param.index)
                  }
                }
              },'删除')
            ])
          }
        },
      ],
      activitiesRewardRules:{
        // 活动奖励优化 - 20200121
        name: [
          {
            required: true, validator: validateActivity.name, trigger: 'blur'
          }
        ],
        couponIds: [
          {
            required: true, validator: validateActivity.couponIds, trigger: 'blur'
          }
        ],
        discountPrice: [
          {
            required: true, validator: validateActivity.discountPrice, trigger: 'blur'
          }
        ],
      },

      // 活动奖励优化 - 20200121
      topTitle: '新增奖励',
      rewardTips: ['', '预订时原价大于等于设置金额，可全单按折扣优惠；设置全单最高减免金额，需支付折扣金额超出部分', '预订时原价大于等于设置金额，可减免设置金额，设置减免金额大于原价时，最多减至应付为0', '', '', '预订时原价大于等于设置金额，可减免房费由低到高的日期房费；设置全单最高减免金额，需支付减房费晚数合计金额超出部分'],
      addEditParams: {
        rewardId: '', // 奖励id
        name: '', // 奖励名称
        type: 3, // 1总金额打折 2满减订单金额 3赠送优惠券 5赠送房晚
        bearType: 2, // 优惠成本(1 - Xbed承担；2 - 业主承担, 默认2)
        originalPrice: null, // 原价满xx元,单位是分,例如原价满100元传10000
        discountPrice: null, // 减免xx元,例如减免100元传10000
        discount: null, // 奖励类型为总金额打折,字段不为空,比如68表示打6.8折
        maxDiscountPrice: null, // 最高减免金额,单位是分,100元传10000
        roomNight: null, // 赠送房晚类型:赠送几个房晚
        rewardBindCouponList: [], // 绑定的卡券数组 ( couponIds: 卡券id; quantity: 卡券数量)
      },
      rewardTypeList: [
        {
          name: '赠送优惠券',
          type: 3,
        },
        {
          name: '预订金额减免',
          type: 2,
        },
        {
          name: '预订金额折扣',
          type: 1,
        },
        {
          name: '预订房晚兑换',
          type: 5,
        },
      ],
      // 添加的优惠券信息
      couponParam: {
        loading: false,
        couponIds: '', // 优惠券id
        couponData: [], // 已添加的优惠券信息
      },
      saveLoading: false
    }
  },
  created () {
    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.addEditParams.rewardId = Number(Utils.getUrlParameterByName( 'id' ))
    
    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6',
      // 'Content-Type': 'application/json;charset=UTF-8'
    }
    // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
    //   this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
    // }
  },
  mounted () {
    this.$Notice.config( {
			top: 200
    } );
    if (this.addEditParams.rewardId) {
      this.topTitle = '奖励详情'
      this.getRewardDetail()
    }
  },
  methods: {
    /**
    * 活动奖励优化  begin
    * add by lty   - 20200211
    */
    // 活动奖励详情
    async getRewardDetail() {
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getRewardDetail(this.addEditParams.rewardId, this.protHeaders)).data;
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取活动详情失败',
            desc: resp.msg
          })
          return
        }
        this.addEditParams.name = resp.name
        this.addEditParams.type = resp.type
        this.addEditParams.bearType = resp.bearType
        this.addEditParams.originalPrice = resp.originalPrice / 100
        switch (resp.type) {
          case 1:
            this.addEditParams.discount = resp.discount / 10
            this.addEditParams.maxDiscountPrice = resp.maxDiscountPrice / 100
            break;
          case 2:
            this.addEditParams.discountPrice = resp.discountPrice / 100
            break;
          case 3:
            this.couponParam.couponData = resp.rewardBindCouponVoList
            break;
          case 5:
            this.addEditParams.roomNight = resp.roomNight
            this.addEditParams.maxDiscountPrice = resp.maxDiscountPrice / 100
            break;
          default:
            break;
        }

      } catch(e) {
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    // 选择奖励类型时初始化优惠信息
    changeType() {
      this.addEditParams = Object.assign(this.addEditParams, {
        bearType: 2,
        originalPrice: null,
        discountPrice: null,
        discount: null,
        maxDiscountPrice: null,
        roomNight: null,
        rewardBindCouponList: []
      })
    },

    // 添加优惠券
    async addCoupon() {
      if (this.couponParam.couponData.length === 10) {
        this.$Notice.error({
          title: '最多只能添加10种优惠券'
        })
        return
      }
      this.couponParam.loading = true
      let validatorResult = false
      this.$refs.addCouponForm.validate((valid) =>{
        validatorResult = valid
      })
      if (!validatorResult) {
        this.couponParam.loading = false
        return
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.checkCardId({cardId: this.couponParam.couponIds}, this.protHeaders)).data;
        this.couponParam.loading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '添加失败',
            desc: resp.msg
          })
          return
        }
        this.couponParam.couponData.push(resp)
        this.couponParam.couponIds = ''
      } catch(e) {
        this.$Notice.error({
					title: '添加失败，请稍后再试'
        })
        this.couponParam.loading = false
      }
    },
    // 删除优惠券
    deleteBtn(index) {
      this.couponParam.couponData.splice(index, 1)
    },
    
    // 保存（新增/编辑）
    async saveAddOrEdit() {
      this.saveLoading = true;
      let validatorResult = false
      this.$refs.activitiesRewardForm.validate((valid) =>{
        validatorResult = valid
      })
      if (!validatorResult) {
        this.saveLoading = false;
        return
      }
      let params = this.addEditParams
      params.userId = this.userId
      if (params.type === 3) {
        if (this.couponParam.couponData.length === 0) {
          this.$Notice.error({
            title: '至少添加一个优惠券'
          })
          this.saveLoading = false;
          return
        } else {
          params.rewardBindCouponList = []
          this.couponParam.couponData.map(item => {
            let addCoupon = {}
            addCoupon.couponIds = item.cardId ? item.cardId : item.couponIds
            addCoupon.quantity = item.quantity || 1
            params.rewardBindCouponList.push(addCoupon)
          })
        }
        params.bearType = ''
      }

      // 过滤空字段
      params = Object.keys(params).reduce(function(c, k) {
        if (params[k] && params[k].length !== 0) {
          if (k === 'originalPrice' || k === 'discountPrice' || k === 'maxDiscountPrice') {
            c[k] = Number((params[k] * 100).toFixed(0))
          } else if (k === 'discount') {
            c[k] = Number((params[k] * 10).toFixed(0))
          } else if (k === 'rewardBindCouponList') {
            c[k] = JSON.stringify(params[k])
          } else {
            c[k] = params[k]
          }
        }
        return c
      }, {})
      
      try {
        let resp
        if (params.rewardId) {
          resp = (await API.omsAPI[this.env].clientServer.editActivityReward(params, this.protHeaders)).data;
        } else {
          resp = (await API.omsAPI[this.env].clientServer.addActivityReward(params, this.protHeaders)).data;
        }
        this.saveLoading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: params.rewardId ? '修改失败' : '新增失败',
            desc: resp.msg
          })
          this.initPrice(params)
          return
        }
        this.$Notice.success({
          title: params.rewardId ? '修改成功' : '新增成功',
        })
        if (!params.rewardId) this.initieParams()
      } catch(e) {
        this.saveLoading = false
        this.initPrice(params)
        this.$Notice.error({
					title: '操作失败，请稍后再试'
        })
      }
    },
    // 初始化参数
    initieParams () {
      this.addEditParams = Object.assign(this.addEditParams, {
        rewardId: '',
        name: '',
        type: 3,
        bearType: 2,
        originalPrice: null,
        discountPrice: null,
        discount: null,
        maxDiscountPrice: null,
        roomNight: null,
        rewardBindCouponList: [],
      })
      this.couponParam.couponData = []
    },
    // 保存失败要还原金额框的参数
    initPrice(params) {
      if (params.originalPrice) this.addEditParams.originalPrice = params.originalPrice / 100
      if (params.discountPrice) this.addEditParams.discountPrice = params.discountPrice / 100
      if (params.maxDiscountPrice) this.addEditParams.maxDiscountPrice = params.maxDiscountPrice / 100
      if (params.discount) this.addEditParams.discount = params.discount / 10
    },
    /**********   活动奖励优化  end   **********/
  }
}
</script>

<style lang="scss" scope>
  .input-unit {
    display: inline-block;
    position: relative;
    margin-left: 9px;
    .input {
      width: 150px;
      margin-left: 4px;
    }
    .unit {
      color: #999;
      position: absolute;
      right: 25px;
      top: 1px;
      line-height: 34px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/marketing/activityRewardContentList.vue